/**
 * Created by JackCui on 2021/12/2
 */

import projectInfo from './project-info'

// 获取ajax url
let aPaaSbizProject = projectInfo.query() || ''
function getPaasAjaxUrl (url) {
  return '/' + aPaaSbizProject + url
}
let re = /^\/apaas\//
function batchHandleUrl (obj) {
  for (let key in obj) {
    if (re.test(obj[key].url)) {
      obj[key].url = getPaasAjaxUrl(obj[key].url)
    }
  }
  return obj
}
export {
  getPaasAjaxUrl,
  batchHandleUrl
}

export default batchHandleUrl
